/* eslint-disable no-console */
/**
 * sections.js
 *
 * Import the JS for your sections here.
 *
 */
import onDOMReady from '../js/utils/onDomReady';

onDOMReady(() => {
    if (document.querySelector('.s-desktop-header')) {
        import('./desktop-header/s-desktop-header').then(() => {
            console.info('Loaded JS: ./desktop-header/s-desktop-header');
        });
    }
    if (document.querySelector('.s-sitemap-kentico ul')) {
        import('./sitemap/s-sitemap-kentico').then(() => {
            console.info('Loaded JS: ./sitemap/s-sitemap-kentico');
        });
    }
    if (document.querySelector('.s-notification')) {
        import('./notification/s-notification').then(() => {
            console.info('Loaded JS: ./notification/s-notification');
        });
    }
    if (document.querySelector('.s-engagement-video')) {
        import('./engagement-video/s-engagement-video').then(() => {
            console.info('Loaded JS: ./engagement-video/s-engagement-video');
        });
    }
    if (document.querySelector('.js-tab-item')) {
        import('./tabs/s-tabs').then(() => {
            console.info('Loaded JS: ./tabs/s-tabs');
        });
    }
    if (document.querySelector('.s-calculator')) {
        import('./calculator/s-calculator').then(() => {
            console.info('Loaded JS: ./calculator/s-calculator');
        });
    }
    if (document.querySelector('.s-content-block')) {
        import('./content-block/s-content-block').then(() => {
            console.info('Loaded JS: ./content-block/s-content-block');
        });
    }
    if (document.querySelector('.s-anchor')) {
        import('./anchor/s-anchor').then(() => {
            console.info('Loaded JS: ./anchor/s-anchor');
        });
    }
    if (document.querySelector('.s-map')) {
        import('./map/s-map').then(() => {
            console.info('Loaded JS: ./map/s-map');
        });
    }
    if (document.querySelector('.s-superbalance')) {
        import('./super-balance/s-super-balance').then(() => {
            console.info('Loaded JS: ./super-balance/s-super-balance');
        });
    }
});
